import { EditType } from "@components/EditableCell"
import { GraphNodeType } from "@custom-types/graphs"
import { ValidationError } from "@features/builder/graph/nodes/validation/types"
import { NodeProperties, NodeType } from "@features/builder/graph/types"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import PropertiesTable from "@features/graph/details/components/PropertiesTable"
import { discreteNodeDistributionProperties } from "@utils/graph"
import { useFormContext } from "react-hook-form"

type DiscretePropertiesTableProps = {
  nodeProperties: NodeProperties
  nodeLabelMap: Record<string, string>
  nodeTypeMap: Record<string, NodeType | GraphNodeType>
  onDistributionChange?: (newDistribution: string, rowIndex: number) => void
  enableSelection?: boolean
  validationErrors?: ValidationError[]
}

const DiscretePropertiesTable = (props: DiscretePropertiesTableProps) => {
  const form = useFormContext<NodeFormValues>()

  return (
    <PropertiesTable
      type={NodeType.Discrete}
      editable
      labelMap={props.nodeLabelMap}
      nodeTypeMap={props.nodeTypeMap}
      properties={props.nodeProperties}
      control={form.control}
      name="properties"
      enableSelection={props.enableSelection}
      validationErrors={props.validationErrors}
      customizeRow={(row, rowIndex) => {
        const updatedRow = { ...row }

        for (const key of Object.keys(updatedRow)) {
          if (!updatedRow[key]) continue

          updatedRow[key].editOnClick = false

          if (key === "distribution") {
            updatedRow[key].editable = true
            updatedRow[key].type = EditType.SingleOption
            updatedRow[key].options = discreteNodesDistributionsOptions
            updatedRow[key].onChange = (newDistribution) =>
              props.onDistributionChange?.(newDistribution as string, rowIndex)
          }

          // overwrite editable if form is disabled
          if (form.formState.disabled) {
            updatedRow[key].editable = false
          }

          const error = form.formState.errors.properties?.[rowIndex]?.[key]
          updatedRow[key].errorMessage = error?.message ?? ""
        }

        return updatedRow
      }}
    />
  )
}

export default DiscretePropertiesTable

const discreteNodesDistributionsOptions = Object.keys(discreteNodeDistributionProperties).map(
  (distribution) => ({ label: distribution, value: distribution }),
)
